export default __webpack_public_path__ + "static/media/plus-svgrepo-com.8bb20c02.svg";